



































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, UsuarioActual } from "../login-controlador";
import { Email } from '@/__env/ext';

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{
    get Controlador() { return Model; }
    get UsuarioActual() { return UsuarioActual; }

    Estado: 'cargando' | 'iniciado' = 'iniciado';
    Error: string = '';
    Email: string = '';

    @Prop()
    Visible: boolean;
    @Watch( 'Visible' )
    onVisible()
    {
        this.Estado = 'iniciado';
        this.Error = '';
        this.Email = '';
    }

    public async Comprobar()
    {


        if ( this.Email.length < 3 && !Email( this.Email) )
        {
            document.getElementById( 'text-email' ).focus();
            this.Error = '¡Ingresá un email válido!';
            return;
        }

        this.Estado = 'cargando';
        let response = await this.Controlador.Comprobar( this.Email.toLowerCase(), 'e' );
        if ( response != "ok" )
        {
            this.Email = '';
            document.getElementById( 'text-email' ).focus();
            if ( response == "datos-incorrectos" )
            {
                this.Error = '¡El email ingresado no existe!';
            }
            else if ( response == "error" )
            {
                this.Error = 'Ocurrió un error en el servicio';
            }
        }
        this.Estado = 'iniciado';
    }

}
